import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { Alert } from '@thd-olt-component-react/alert';

export const DefaultShipping = ({ shippingMessageStyle, alertType, shippingMessage }) => {
  const iconSelector = alertType === 'close'
    ? <Alert type="close" message={' '} inline />
    : <img src="https://assets.homedepot-static.com/images/v1/Available.svg" alt="Available Shipping" />;

  const shippingCss = classNames(shippingMessageStyle + ' shipping__second-line');

  return (
    <div className="shipping__message">
      <div className="shipping__icon">
        {iconSelector}
      </div>
      <div className="shipping__text-box">
        <div className="shipping__dark">Delivery</div>
        <div className={shippingCss}>{shippingMessage}</div>
      </div>
    </div>
  );
};

DefaultShipping.propTypes = {
  shippingMessageStyle: string,
  alertType: string,
  shippingMessage: string
};

DefaultShipping.defaultProps = {
  shippingMessageStyle: 'shipping__primary',
  alertType: 'close',
  shippingMessage: 'Unavailable',
};
